const EventsTableEmptyRow = ({ columns, openCreate }) => <tr>
    <td colSpan={columns.length}>There are no events available. Click <button className="anchor" onClick={openCreate}>here</button> to create one</td>
</tr>;

export default EventsTableEmptyRow;